/**
 * INVENTARIO PAGE - Gestión de Inventario
 */
import { Package } from "lucide-react";
import { PlaceholderPage } from "../placeholder-page";

export default function InventarioPage() {
  return (
    <PlaceholderPage
      titleKey="inventario.title"
      descriptionKey="inventario.description"
      icon={Package}
    />
  );
}
